// extracted by mini-css-extract-plugin
export default {"container":"BooksList_container__Jq6a5","no-book-indicator":"BooksList_no-book-indicator__udxx5"};